import rosterApi from '../api/rosterApi'

export default {
    async getPlantData() {
        let plantData = await rosterApi.getPlantData();
        return plantData;
    },
    async getFinancialYearCalendarsData() {
        let financialYearCalendarsData = await rosterApi.getFinancialYearCalendarsData();
        return financialYearCalendarsData;
    },
    async getWeatherData(plantID, startDate, endDate) { 
        let weatherData = await rosterApi.getWeatherData(
            plantID,
            startDate,
            endDate
        );
        return weatherData;
    },
    async getCropLocationVarietyRosters(plantID, productCategoryIDs, startDate, endDate, cropLocationID) {
        let cropLocationVarietyRosters = await rosterApi.getCropLocationVarietyRosters(
            plantID,
            productCategoryIDs,
            startDate,
            endDate,
            cropLocationID
        );
        return cropLocationVarietyRosters;
    },
    async updateRosterTeamPlans(rosterTeamPlans) {
        return await rosterApi.updateRosterTeamPlans(rosterTeamPlans);
    },
    async getRosterTeamPlans(plantID, productCategoryIDs, startDate, endDate) {
        let rosterTeamPlans = await rosterApi.getRosterTeamPlans(
            plantID,
            productCategoryIDs,
            startDate,
            endDate
        );
        return rosterTeamPlans;
    },
    async cleanUpRosterTeamPlans(plantID, startDate, endDate) {
        await rosterApi.cleanUpRosterTeamPlans(
            plantID,
            startDate,
            endDate
        );
    },
    async loadTeamRosterResult(teamIDs, startDate, endDate) {
        let teamRosterResult = await rosterApi.loadTeamRosterResult(
            teamIDs,
            startDate,
            endDate
        );
        return teamRosterResult;
    },
}